<template>
    <div class="col-md-12">
        <div class="row mb-3 d-flex justify-content-between">
            <h4 class="col-md-8 col-sm-12 font-weight-bold">Metas</h4>
            <button
                class="col-auto btn btn-primary mr-3"
                @click="showAddItem = true"
            >
                Adicionar meta
            </button>
        </div>
        <div class="row">
            <div class="col-12 checklist-progress" v-if="progress > 0">
                <div class="progress">
                    <div
                        class="progress-bar"
                        role="progressbar"
                        :style="`width: ${progress}%`"
                        :aria-valuenow="progress"
                        aria-valuemin="0"
                        aria-valuemax="100"
                    >
                        {{ progress }}%
                    </div>
                </div>
            </div>

            <div class="col-12" attr="newItem" v-if="showAddItem">
                <form-select-input
                    v-model="newItem"
                    class="px-0"
                    label="Selecione ou digite uma nova meta"
                    :itens="metas"
                    :multiple="true"
                    placeholder="Selecione ou digite uma nova meta"
                    @insert="inserirTipo"
                />
                <div class="d-flex justify-content-end">
                    <button class="btn btn-danger" @click="showAddItem = false">
                        Cancelar
                    </button>
                    <button class="btn btn-success" @click="addItem">
                        Salvar
                    </button>
                </div>
            </div>
            <load mode="table" text="Aguarde um momento." v-if="loading" />
            <div v-else>
                <div
                    class="col-12"
                    v-for="(item, index) in metasItens"
                    :key="index"
                >
                    <div role="group" class="form-group mb-2">
                        <toggle-button
                            @change="update"
                            v-model="item.status"
                            :sync="true"
                            color="#5685D8"
                        />
                        <span
                            :class="item.status ? 'meta_check' : ''"
                            v-html="item.descricao"
                        >
                        </span>
                        <!-- <i
										class="mdi mdi-close text-danger clickable"
										@click="excluir(index, item.descricao)"
									></i> -->
                    </div>
                </div>
                <h4
                    class="text-secondary ml-2"
                    v-if="isEmpty(metasItens) || metasItens.length <= 0"
                >
                    <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
                    Nenhuma meta registrada.
                </h4>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["acompanhamento", "status"],
    data() {
        return {
            loading: false,
            showAddItem: false,
            editItem: null,
            newItem: "",
            metasItens: {},
            metas: {},
        };
    },

    mounted() {
        if (this.acompanhamento.metas) {
            this.metasItens = this.acompanhamento.metas;
            this.newItem = this.acompanhamento.metas.map(
                (elem) => elem.descricao
            );
        }
        this.geTipos();
    },
    computed: {
        progress() {
            var total = this.metasItens.length;
            var complete = 0;

            for (var i = 0; i < this.metasItens.length; i++) {
                if (this.metasItens[i].status) {
                    complete++;
                }
            }
            var porcento = ((total - complete) * 100) / total;

            if (porcento > 100) {
                porcento = 100;
            }

            return 100 - Math.round(porcento);
        },
    },
    methods: {
        geTipos() {
            axios
                .post("api/dashboard/admin/getTipos", {
                    model: "Meta",
                    module: "Configuracao",
                })
                .then((response) => {
                    this.setTipos(response.data.data);
                });
        },
        setTipos(data) {
            this.metas = data.map((elem) => ({
                id: elem.descricao,
                value: elem.descricao,
            }));
        },
        addItem() {
            this.showAddItem = false;
            this.loading = true;
            axios
                .post("api/dashboard/metas/store", {
                    paf_id: this.acompanhamento.id,
                    itens: this.newItem,
                })
                .then((response) => {
                    this.$snack.success({
                        button: false,
                        text: "Meta(s) inserida(s) com sucesso.",
                    });
                    this.metasItens = response.data.itens;
                    this.acompanhamento.metas = response.data.itens;
                    this.loading = false;
                });
        },
        update() {
            this.loading = true;
            axios
                .post("api/dashboard/metas/update", {
                    paf_id: this.acompanhamento.id,
                    itens: this.metasItens,
                })
                .then((response) => {
                    this.loading = false;
                });
        },
        excluir(index, descricao) {
            var k = this.newItem.indexOf(descricao);

            this.newItem.splice(k, 1);
            this.metasItens.splice(index, 1);

            axios
                .post("api/dashboard/metas/delete", {
                    paf_id: this.acompanhamento.id,
                    itens: this.metasItens,
                })
                .then((response) => {
                    this.loading = false;
                });
        },
        inserirTipo(tipo) {
            this.loading = true;
            axios
                .post("api/dashboard/admin/tipos", {
                    descricao: tipo,
                    model: "Meta",
                    module: "Configuracao",
                })
                .then((response) => {
                    this.$snack.success({
                        button: false,
                        text: "Meta cadastrada com sucesso.",
                    });
                    this.setTipos(response.data.data);

                    this.loading = false;
                });
        },
        isEmpty(obj) {
            return Object.keys(obj).length === 0 && obj.constructor === Object;
        },
    },
};
</script>
<style lang="css">
.progress {
    height: 18px !important;
}
.meta_check {
    text-decoration: line-through !important;
}
.clickable {
    cursor: pointer;
}
</style>
